import { makeStyles } from '@material-ui/core/styles';

const styles = theme => ({
  cityImage: {
    [theme.breakpoints.down('sm')]: {
      width: 100,
      margin: 0
    },
    width: 150,
    margin: '0 10px'
  },
  images: {
    marginTop: 60
  },
  nation: {
    marginBottom: 14,
  },
  nationLabel: {
    color: 'rgba(0, 0, 0, 0.87)',
    fontFamily: 'sofia-bold'
  },
  links: {
  },
  cityLink: {
    textDecoration: 'none',
    margin: '0 10px',
    color: '#a1a1a1',
    fontWeight: 400
  }
})

export default makeStyles(styles)
